"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TagInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _tags = require("@design/components/shadcncraft/pro-application/tags");
var _portalLayer = require("@common/components/share/portal-layer");
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _useDebouncedValue = require("@common/hooks/use-debounced-value");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TagInput = exports.TagInput = function TagInput(_ref) {
  var id = _ref.id,
    selectedTags = _ref.selectedTags,
    onTagsChange = _ref.onTagsChange,
    searchTags = _ref.searchTags,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "Add a tag..." : _ref$placeholder,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    availableTags = _ref.availableTags;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    query = _useState4[0],
    setQuery = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    searchedTags = _useState6[0],
    setSearchedTags = _useState6[1];
  var _useState7 = (0, _react.useState)(""),
    _useState8 = _slicedToArray(_useState7, 2),
    searchedQuery = _useState8[0],
    setSearchedQuery = _useState8[1];
  var trimmedQuery = query.trim();
  var debouncedQuery = (0, _useDebouncedValue.useDebouncedValue)(trimmedQuery, _useDebouncedValue.SEARCH_DEBOUNCE_MS);
  (0, _react.useEffect)(function () {
    if (availableTags || !debouncedQuery) return;
    var isStale = false;
    function settleSearch(tags) {
      if (isStale) return;
      setSearchedTags(tags);
      setSearchedQuery(debouncedQuery);
    }
    searchTags(debouncedQuery).then(settleSearch, function () {
      return settleSearch([]);
    });
    return function () {
      isStale = true;
    };
  }, [availableTags, debouncedQuery, searchTags]);
  var candidateTags = availableTags !== null && availableTags !== void 0 ? availableTags : trimmedQuery ? searchedTags.map(function (tag) {
    return tag.name;
  }) : [];
  var suggestedTags = candidateTags.filter(function (tag) {
    return (0, _foldedTextSearch.matchesSearch)(tag, trimmedQuery) && !selectedTags.includes(tag);
  });
  var isLoading = !availableTags && trimmedQuery.length > 0 && searchedQuery !== trimmedQuery;
  var canCreateTag = trimmedQuery.length > 0 && !selectedTags.includes(trimmedQuery) && !suggestedTags.includes(trimmedQuery);
  function changeOpen(open) {
    setIsOpen(open);
    setQuery("");
  }
  function addTag(tag) {
    onTagsChange([].concat(_toConsumableArray(selectedTags), [tag]));
    setQuery("");
  }
  function removeTag(tagToRemove) {
    onTagsChange(selectedTags.filter(function (tag) {
      return tag !== tagToRemove;
    }));
  }
  var selectedTagsRow = selectedTags.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "mb-2 flex flex-wrap gap-1.5",
    children: selectedTags.map(function (tag) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tags.TagsSelectedValue, {
        onRemove: disabled ? undefined : function () {
          return removeTag(tag);
        },
        children: tag
      }, tag);
    })
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-sentry-component": "TagInput",
    "data-sentry-source-file": "TagInput.tsx",
    children: [selectedTagsRow, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_tags.Tags, {
      modal: true,
      open: isOpen,
      onOpenChange: changeOpen,
      className: "max-w-none",
      "data-sentry-element": "Tags",
      "data-sentry-source-file": "TagInput.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_tags.TagsTrigger, {
        id: id,
        disabled: disabled,
        "data-sentry-element": "TagsTrigger",
        "data-sentry-source-file": "TagInput.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_tags.TagsContent, _objectSpread(_objectSpread({}, _portalLayer.PORTAL_LAYER_PROPS), {}, {
        align: "start",
        shouldFilter: false,
        "data-sentry-element": "TagsContent",
        "data-sentry-source-file": "TagInput.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_tags.TagsInput, {
          autoFocus: true,
          placeholder: placeholder,
          value: query,
          onValueChange: setQuery,
          "data-sentry-element": "TagsInput",
          "data-sentry-source-file": "TagInput.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_tags.TagsList, {
          "data-sentry-element": "TagsList",
          "data-sentry-source-file": "TagInput.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_tags.TagsEmpty, {
            "data-sentry-element": "TagsEmpty",
            "data-sentry-source-file": "TagInput.tsx",
            children: isLoading ? "Loading…" : "No tags found."
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_tags.TagsGroup, {
            "data-sentry-element": "TagsGroup",
            "data-sentry-source-file": "TagInput.tsx",
            children: [suggestedTags.map(function (tag) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tags.TagsItem, {
                value: tag,
                onSelect: function onSelect() {
                  return addTag(tag);
                },
                children: tag
              }, tag);
            }), canCreateTag ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_tags.TagsItem, {
              value: "create:".concat(trimmedQuery),
              onSelect: function onSelect() {
                return addTag(trimmedQuery);
              },
              children: ["Create \"", trimmedQuery, "\""]
            }) : null]
          })]
        })]
      }))]
    })]
  });
};
var _default = exports.default = TagInput;